import sidebarMenus from '@/assets/js/menu/SidebarMenus'
import settingMenus from '@/assets/js/menu/SettingMenus'
import attributeMenus from '@/assets/js/menu/AttributeMenus'
import memberSettingsMenus from '@/assets/js/menu/MemberSettingsMenus'
import prototypeAttributes from '@/assets/js/menu/PrototypeAttributes'
import reports from '@/views/newReport/utils/reports.json'

const reportMenus = reports.map((report) => ({
  title: report.nameEn,
  icon: 'mdi-file-chart-outline',
  to: report.to,
  keywords: [report.nameTh, report.searchDescription, ...(report.categories || [])].filter(Boolean)
}))

export default [
  { group: '', items: sidebarMenus },
  { group: 'Setting', items: settingMenus },
  { group: 'Attributes', items: attributeMenus },
  { group: 'Member Settings', items: memberSettingsMenus },
  { group: 'Prototype Attributes', items: prototypeAttributes },
  { group: 'Report Hub', items: reportMenus }
]
